import { ConditionalDynamicDisplayElement } from '../base/conditional-dynamic-display-element';
export class RectangleElement extends ConditionalDynamicDisplayElement {
    constructor(element, permissionChecker, variableCommunicator, variableStore) {
        super(element, permissionChecker, variableCommunicator, variableStore);
    }
}
